import { useFilterEmployeePenaltyContext } from "./filter-employee-penalty.context";

export function FilterEmployeePenalty() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmployeePenaltyContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}